export function isCurrent({
  fromDate,
  toDate,
}: {
  fromDate: Date;
  toDate?: Date;
}) {
  const currentDate = new Date();
  return (
    fromDate <= currentDate && (toDate === undefined || toDate >= currentDate)
  );
}
